(function () {
  "use strict";

  var VERSION = "1.0.2";
  var ENDPOINT = "https://zoiotqenzragachunpoh.supabase.co/functions/v1/track-event";
  var SESSION_STORAGE_KEY = "tm_attr_session_v1";
  var TOUCH_STORAGE_KEY = "tm_attr_last_touch_v1";
  var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  var TOUCH_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var started = false;

  function debug() {
    if (!window.TM_ATTRIBUTION_DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[TM Attribution]");
    console.log.apply(console, args);
  }

  function safeParse(value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (_) {
      return null;
    }
  }

  function storageGet(key) {
    try {
      return safeParse(window.localStorage.getItem(key));
    } catch (_) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_) {
      return false;
    }
  }

  function randomId(prefix) {
    var id;
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      id = window.crypto.randomUUID();
    } else if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      id = Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
    } else {
      id = String(Date.now()) + "_" + Math.random().toString(36).slice(2);
    }
    return prefix + id.replace(/[^A-Za-z0-9_-]/g, "");
  }

  function validParam(value) {
    if (typeof value !== "string") return null;
    var clean = value.trim();
    if (!clean || clean.length > 512) return null;
    var lower = clean.toLowerCase();
    if (lower === "null" || lower === "undefined" || lower === "none") return null;
    if (clean.indexOf("{{") !== -1 || clean.indexOf("}}") !== -1) return null;
    if (clean.indexOf("__") !== -1 || clean.indexOf("{") !== -1 || clean.indexOf("}") !== -1) return null;
    return clean;
  }

  function firstParam(params, names) {
    for (var i = 0; i < names.length; i += 1) {
      var value = validParam(params.get(names[i]));
      if (value) return value;
    }
    return null;
  }

  function readCurrentTouch() {
    var params = new URL(window.location.href).searchParams;
    var touch = {
      utm_source: firstParam(params, ["utm_source"]),
      utm_medium: firstParam(params, ["utm_medium"]),
      utm_campaign: firstParam(params, ["utm_campaign"]),
      utm_content: firstParam(params, ["utm_content"]),
      utm_term: firstParam(params, ["utm_term"]),
      fbclid: firstParam(params, ["fbclid"]),
      gclid: firstParam(params, ["gclid", "gbraid", "wbraid"]),
      ttclid: firstParam(params, ["ttclid"]),
      external_campaign_id: firstParam(params, [
        "tm_campaign_id",
        "campaign_id",
        "campaignid",
        "utm_id"
      ]),
      external_ad_group_id: firstParam(params, [
        "tm_adset_id",
        "tm_ad_group_id",
        "adset_id",
        "adsetid",
        "ad_group_id",
        "adgroupid"
      ]),
      external_ad_id: firstParam(params, [
        "tm_ad_id",
        "ad_id",
        "adid",
        "tw_adid"
      ])
    };

    var hasAttribution = Object.keys(touch).some(function (key) {
      return Boolean(touch[key]);
    });

    return hasAttribution ? touch : null;
  }

  function touchFingerprint(touch) {
    if (!touch) return "";
    return [
      touch.fbclid,
      touch.gclid,
      touch.ttclid,
      touch.external_campaign_id,
      touch.external_ad_group_id,
      touch.external_ad_id,
      touch.utm_source,
      touch.utm_campaign
    ].filter(Boolean).join("|");
  }

  function getStoredTouch(now) {
    var stored = storageGet(TOUCH_STORAGE_KEY);
    if (!stored || !stored.touch || !stored.captured_at) return null;
    if (now - Number(stored.captured_at) > TOUCH_TTL_MS) return null;
    return stored.touch;
  }

  function getOrCreateContext() {
    var now = Date.now();
    var currentTouch = readCurrentTouch();
    var session = storageGet(SESSION_STORAGE_KEY);
    var expired = !session || !session.id || now - Number(session.last_seen_at || 0) > SESSION_TIMEOUT_MS;
    var changedPaidClick = Boolean(
      currentTouch &&
      session &&
      session.touch_fingerprint &&
      touchFingerprint(currentTouch) !== session.touch_fingerprint
    );

    if (expired || changedPaidClick) {
      session = {
        id: randomId("tm_"),
        started_at: now,
        last_seen_at: now,
        sent_landing: false,
        touch_fingerprint: currentTouch ? touchFingerprint(currentTouch) : ""
      };
    } else {
      session.last_seen_at = now;
      if (currentTouch) session.touch_fingerprint = touchFingerprint(currentTouch);
    }

    if (currentTouch) {
      storageSet(TOUCH_STORAGE_KEY, { touch: currentTouch, captured_at: now });
    }

    storageSet(SESSION_STORAGE_KEY, session);
    return {
      session: session,
      touch: currentTouch || getStoredTouch(now) || {}
    };
  }

  function buildPayload(eventType, extra) {
    var context = getOrCreateContext();
    var payload = {
      event_id: randomId("evt_"),
      session_key: context.session.id,
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      page_url: window.location.href,
      referrer: document.referrer || null,
      page_title: document.title || null,
      browser_language: navigator.language || null
    };

    Object.keys(context.touch).forEach(function (key) {
      if (context.touch[key]) payload[key] = context.touch[key];
    });

    Object.keys(extra || {}).forEach(function (key) {
      if (extra[key] !== undefined && extra[key] !== null && extra[key] !== "") {
        payload[key] = extra[key];
      }
    });

    return payload;
  }

  function send(eventType, extra) {
    var payload = buildPayload(eventType, extra);
    debug("send", eventType, payload);

    return window.fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      mode: "cors",
      credentials: "omit",
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error("track-event HTTP " + response.status);
      return response.json();
    }).then(function (result) {
      debug("saved", result);
      return result;
    }).catch(function (error) {
      debug("failed", error);
      return { ok: false, error: String(error) };
    });
  }

  function normalizeKey(key) {
    return String(key).toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function findIdentityValue(root, wantedKeys, depth, seen) {
    if (!root || depth > 4 || typeof root !== "object") return null;
    if (seen.indexOf(root) !== -1) return null;
    seen.push(root);

    var keys;
    try {
      keys = Object.keys(root);
    } catch (_) {
      return null;
    }

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = root[key];
      if (wantedKeys.indexOf(normalizeKey(key)) !== -1 && (typeof value === "string" || typeof value === "number")) {
        return String(value);
      }
    }

    for (var j = 0; j < keys.length; j += 1) {
      var nested = root[keys[j]];
      var found = findIdentityValue(nested, wantedKeys, depth + 1, seen);
      if (found) return found;
    }
    return null;
  }

  function easySellField(name) {
    if (typeof window.es_get_field_value !== "function") return null;
    try {
      return window.es_get_field_value(name) || null;
    } catch (_) {
      return null;
    }
  }

  function identityFromEasySell(value) {
    var root = value && typeof value === "object" ? value : {};
    return {
      phone: findIdentityValue(root, ["phone", "phonenumber", "telephone", "tel"], 0, []) || easySellField("phone"),
      email: findIdentityValue(root, ["email", "emailaddress"], 0, []) || easySellField("email")
    };
  }

  function currentSessionKey() {
    var session = storageGet(SESSION_STORAGE_KEY);
    if (session && session.id) return session.id;
    return getOrCreateContext().session.id;
  }

  function eventIdPart(value) {
    return String(value || "")
      .replace(/[^A-Za-z0-9_-]/g, "")
      .slice(0, 80);
  }

  function bindEasySellHooks() {
    var existingBeforeSubmit = window.es_hook_before_submit;
    var existingPurchaseSuccess = window.es_hook_purchase_success;

    window.es_hook_before_submit = function () {
      var existingResult;
      if (typeof existingBeforeSubmit === "function") {
        try {
          existingResult = existingBeforeSubmit.apply(this, arguments);
        } catch (error) {
          debug("existing es_hook_before_submit failed", error);
        }
      }
      var beforeIdentity = identityFromEasySell(arguments[0]);
      beforeIdentity.event_id = "es_before_" + eventIdPart(currentSessionKey());
      send("before_submit", beforeIdentity);
      return existingResult;
    };

    window.es_hook_purchase_success = function (order) {
      var existingResult;
      if (typeof existingPurchaseSuccess === "function") {
        try {
          existingResult = existingPurchaseSuccess.apply(this, arguments);
        } catch (error) {
          debug("existing es_hook_purchase_success failed", error);
        }
      }
      var purchaseIdentity = identityFromEasySell(order);
      var orderId = order && (order.id || order.orderId || order.order_id);
      purchaseIdentity.event_id = "es_purchase_" + eventIdPart(orderId || currentSessionKey());
      send("purchase_success", purchaseIdentity);
      return existingResult;
    };
  }

  function startTracking() {
    if (started) return;
    started = true;

    var context = getOrCreateContext();
    var eventType = context.session.sent_landing ? "page_view" : "landing";
    send(eventType).then(function () {
      var latest = storageGet(SESSION_STORAGE_KEY);
      if (latest) {
        latest.sent_landing = true;
        latest.last_seen_at = Date.now();
        storageSet(SESSION_STORAGE_KEY, latest);
      }
    });
    bindEasySellHooks();
    debug("started", VERSION, context.session.id);
  }

  function marketingTrackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== "function") return true;
    return privacy.marketingAllowed();
  }

  function startWhenAllowed() {
    if (marketingTrackingAllowed()) startTracking();
  }

  document.addEventListener("visitorConsentCollected", function (event) {
    if (event.detail && event.detail.marketingAllowed) startTracking();
  });
  document.addEventListener("trackingConsentAccepted", startWhenAllowed);

  window.TrendomaniaAttribution = {
    version: VERSION,
    start: startWhenAllowed,
    track: send,
    getSessionKey: function () {
      var session = storageGet(SESSION_STORAGE_KEY);
      return session && session.id ? session.id : null;
    },
    getLastTouch: function () {
      return getStoredTouch(Date.now());
    }
  };

  if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([
      { name: "consent-tracking-api", version: "0.1" }
    ], function (error) {
      if (error) {
        debug("Customer Privacy API load error", error);
        startTracking();
        return;
      }
      startWhenAllowed();
    });
  } else {
    startWhenAllowed();
  }
})();